import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';

const ACCENT_BLUE = '#22638f';
const TEXT_MUTED = '#93a0b5';
const TEXT_BODY = '#3b4a63';
const BORDER = '#eef2f8';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: '#fff',
  borderRadius: '14px',
  boxShadow: '0 8px 32px rgba(12, 61, 110, 0.14)',
  p: 0,
};

const primaryBtnSx = {
  textTransform: 'none',
  fontWeight: 700,
  fontSize: '13px',
  color: '#fff',
  backgroundColor: ACCENT_BLUE,
  borderRadius: '8px',
  padding: '8px 22px',
  boxShadow: 'none',
  '&:hover': { backgroundColor: '#1a4d70', boxShadow: 'none' },
};

const closeBtnSx = {
  textTransform: 'none',
  fontWeight: 700,
  fontSize: '13px',
  color: TEXT_MUTED,
  border: `1px solid ${BORDER}`,
  borderRadius: '8px',
  padding: '8px 18px',
  '&:hover': { backgroundColor: '#f8fbfe', borderColor: TEXT_MUTED },
};

function AppMessageModel({ open, setOpen, title, message, actions }) {
  const handleClose = () => { setOpen(!open) }
  return (
    <div>
      <Modal open={open} onClose={handleClose}>
        <Box sx={style}>
          <Box
            sx={{
              padding: '18px 24px',
              borderBottom: `1px solid ${BORDER}`,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
            }}
          >
            <Typography sx={{ fontSize: 16, fontWeight: 700, color: TEXT_BODY }}>
              {title}
            </Typography>
            <IconButton onClick={handleClose} size="small" sx={{ color: TEXT_MUTED }} aria-label="Close">
              <CloseIcon fontSize="small" />
            </IconButton>
          </Box>

          <Box sx={{ padding: '20px 24px' }}>
            {message && (
              <Typography sx={{ fontSize: 14, color: TEXT_BODY }}>
                {message}
              </Typography>
            )}
          </Box>

          <Box
            sx={{
              padding: '16px 24px',
              borderTop: `1px solid ${BORDER}`,
              display: 'flex',
              justifyContent: 'flex-end',
              gap: 1,
            }}
          >
            {actions && actions.map((action, index) => (
              <Button
                key={index}
                sx={primaryBtnSx}
                onClick={() => {
                  action.onClick();
                  handleClose();
                }}
              >
                {action.label}
              </Button>
            ))}
            <Button sx={closeBtnSx} onClick={handleClose}>
              Close
            </Button>
          </Box>
        </Box>
      </Modal>
    </div>
  )
}

export default AppMessageModel